import { LAYOUT_HEADER_HEIGHT } from "@/constants/Layout";
import {
  useAppLayoutSidebarCollapsed,
  useAppLayoutSidebarWidth,
} from "@/modules/app-layout/app-layout-sidebar";
import { useTheme, useThemeBreakpoints } from "@/services/theme";

export const useAppLayoutHeaderSizes = () => {
  const theme = useTheme();
  const logoContainerWidth = useLogoContainerWidth();

  const organizationPadding = theme.token.paddingXS as number;
  const cssVars = `--stelar-layout-header-organization-padding: 0 ${organizationPadding}px;`;

  return {
    cssVars,
    logoContainerWidth,
    organizationDropdownPosition: {
      top: LAYOUT_HEADER_HEIGHT,
      left: logoContainerWidth + organizationPadding,
    },
  };
};

const useLogoContainerWidth = () => {
  const { isXs } = useThemeBreakpoints();
  const { collapsed } = useAppLayoutSidebarCollapsed();
  const { width: sidebardWidth } = useAppLayoutSidebarWidth();

  if (isXs) return 160; // logo + menu button + padding

  if (collapsed) return 140; // logo + padding

  return sidebardWidth;
};
